// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InventoryCardList.css */
.inv-card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 12px;
}

.inv-card-wrapper {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 12px); /* 4 cards per row */
    max-width: calc(25% - 12px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

@media (max-width: 1300px) {
    .inv-card-wrapper {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(33% - 12px); /* 2 cards per row on smaller screens */
        max-width: calc(33% - 12px);
    }
}

@media (max-width: 1000px) {
    .inv-card-wrapper {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 12px); /* 2 cards per row on smaller screens */
        max-width: calc(50% - 12px);
    }
}

@media (max-width: 576px) {
    .inv-card-wrapper {
        flex: 1 1 100%; /* 2 cards per row on mobile screens */
        max-width: 100%;
    }
}

.card-stats {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/inventory-card-list.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,oBAAoB;IAChD,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B,EAAE,uCAAuC;QACnE,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B,EAAE,uCAAuC;QACnE,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,cAAc,EAAE,sCAAsC;QACtD,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;AAChB","sourcesContent":["/* InventoryCardList.css */\n.inv-card-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    gap: 12px;\n}\n\n.inv-card-wrapper {\n    flex: 1 1 calc(25% - 12px); /* 4 cards per row */\n    max-width: calc(25% - 12px);\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n}\n\n@media (max-width: 1300px) {\n    .inv-card-wrapper {\n        flex: 1 1 calc(33% - 12px); /* 2 cards per row on smaller screens */\n        max-width: calc(33% - 12px);\n    }\n}\n\n@media (max-width: 1000px) {\n    .inv-card-wrapper {\n        flex: 1 1 calc(50% - 12px); /* 2 cards per row on smaller screens */\n        max-width: calc(50% - 12px);\n    }\n}\n\n@media (max-width: 576px) {\n    .inv-card-wrapper {\n        flex: 1 1 100%; /* 2 cards per row on mobile screens */\n        max-width: 100%;\n    }\n}\n\n.card-stats {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
